<template>
  <div class="bill_printing"
       v-loading='fullscreenLoading'>
    <div class="print_control">
      <!-- <el-form :model="">
        <el-form-item label=""></el-form-item>
      </el-form> -->
      <el-button type="primary"
                 class="el-icon-printer"
                 v-print="printObj"></el-button>
      <!-- <el-button type="primary"
                 class="el-icon-printer"></el-button> -->
    </div>
    <div class="print_browse">
      <div class="print_browse_main"
           id='printJS-form'>
        <!-- 顶部信息 -->
        <div class="print_browse_top">
          <div class="print_browse_title">对账单
          </div>
          <div class="print_browse_date">

            日期: {{printData.createtime}}
            <br>
            账单号:{{printData.payid}}
            <br>
            团运国际物流有限责任公司

          </div>

        </div>
        <div class="print_browse_mid">
          <div class="customer_name">客服名称: {{printData.name}}</div>
          <div class="customer_message">
            <div class="customer_message_site">
              地址:{{ordertablesz.address}}
            </div>
            <div class="customer_message_contacts">联系人: {{ordertablesz.reconciliation_name}}</div>
            <div class="customer_message_mobile">联系电话: {{ordertablesz.mobile}}</div>
          </div>
          <el-table :data="tableData"
                    border
                    style="width: 100%">
            <el-table-column label="日期"
                             width="100">
              <template slot-scope="scope">
                {{getDateType(scope.row.createtime)}}
              </template>
            </el-table-column>
            <el-table-column label="单号"
                             prop="wlnum"
                             width="150">
            </el-table-column>
            <el-table-column label="目的地"
                             width="200">
              <template slot-scope="scope">
                {{scope.row.sjcity+scope.row.sjprovince+scope.row.sjaddress}}
              </template>
            </el-table-column>

            <el-table-column label="渠道类型"
                             prop="bjname">
            </el-table-column>
            <el-table-column prop="bgnum"
                             label="件数">
            </el-table-column>
            <el-table-column label="重量/立方">
              <template slot-scope="scope">
                {{getJztype(scope.row.bjinfo)?getJztype(scope.row.bjinfo,1)+'kg':getJztype(scope.row.bjinfo,1)+'M³'}}
              </template>
            </el-table-column>
            <el-table-column label="附加费"
                             width="100">
              <template slot-scope="scope">
                <el-tooltip placement="top">

                  <div slot="content"
                       style="max-width:200px">备注: {{scope.row.otherpriceinfo}}
                  </div>
                  <span>
                    {{scope.row.otherprice== null?0:scope.row.otherprice}}

                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="allprice"
                             label="总金额CNY">
            </el-table-column>

            <el-table-column label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.info"
                          type="textarea"
                          :autosize="{ minRows: 1, maxRows: 4}"
                          class="bzinfo"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <div class="customer_total">
            <span class="customer_lable">TOTAL： </span>
            ￥{{printData.allprice}}
          </div>
        </div>
        <div class="print_browse_bottom">
          <div class="price_think">
            本期应付：<span class='price'>￥{{printData.allprice}}元</span>
          </div>
          <div class="private_play">
            <div class="private_play_title">
              对公:
            </div>
            <ul>
              <li v-for="item in bank.g"
                  v-html="item"
                  :key="item">
              </li>
            </ul>
            <br>
            <div class="private_play_title">
              对私:
            </div>
            <ul>
              <li v-for="item in bank.p"
                  v-html="item"
                  :key="item">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script> 
import common from '@/assets/js/common'
import { apiManageBill, apiManageTimeBill, apiBill, apiTimeBill, apiUserData } from '@/request/api'
export default {
  naem: 'BillingDetails',
  data () {
    return {
      ordertablesz: '',
      //bank
      bank: '',
      //报价方案
      bjinfo: '',
      //加载
      fullscreenLoading: false,
      skinfo: '',
      printData: '',
      printObj: {
        id: "printJS-form",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      tableData: [

      ],
      order_id: ''
    }
  },
  methods: {
    //获取报价表数据
    async get_ordertablesz_list () {

      if (this.$store.state.userInfo.ordertablesz.address) {
        this.ordertablesz = this.$store.state.userInfo.ordertablesz
      } else {
        this.$message.error('您还未添加对账单公司信息,三秒后为您跳转填写信息界面')
      }
    },
    //报价info
    getJztype (data, flag) {
      if (data) {
        if (flag === 1) {
          return data.weight

        }
        return data.jztype == 1
      }

    },
    //时间再封装
    getDateType (data) {
      let test = ''
      common.formatDate(data, (y, m, d) => {
        test = `${y}-${m}-${d}`
      })
      return test
    },

    //打印
    print (e) {
      this.$print(this.$refs.print)
    },
    async getTableData (flag) {
      this.fullscreenLoading = true
      if (common.isOrderManagement(this.$store.state.jurisdiction.menu, 'fdadmin')) {
        let flag = true
      }
      let res = ''
      if (flag) {
        res = await apiManageBill({
          soaid: this.order_id,
          pd: 'getlist',
          pageSize: 100,
          page: 1
        })
      } else {
        res = await apiTimeBill({
          soaid: this.order_id,
          pd: 'getlist',
          pageSize: 100,
          page: 1
        })
      }

      this.fullscreenLoading = false
      this.tableData = res.orderlist
    },
    async getprintData (flag) {
      this.fullscreenLoading = true
      if (common.isOrderManagement(this.$store.state.jurisdiction.menu, 'fdadmin')) {
        let flag = true
      }
      let res = ''
      if (flag) {
        res = await apiManageTimeBill({
          payid: this.$route.query.payid,
        })
      } else {
        res = await apiBill({
          payid: this.$route.query.payid,
        })
      }
      this.printData = res.soalist[0]
      this.skinfo = res.skinfo
      this.bank = this.skinfo.bank
      common.formatDate(this.printData.createtime, (y, m, d) => {
        this.printData.createtime = `${y}-${m}-${d}`
      })
      this.fullscreenLoading = false

    }

  },
  mounted () {
  },
  async created () {
    this.order_id = 1
    this.get_ordertablesz_list()
    if (this.$store.state.jurisdiction == '') {
      const res = await apiUserData({
        uid: this.$store.state.uid
      })
      this.$store.commit('upJurisdiction', res.permission)
    }

    if (common.isOrderManagement(this.$store.state.jurisdiction.menu, 'fdadmin')) {
      console.log(11);
      this.getTableData(true)
      this.getprintData(true)
    } else {
      console.log(111);
      this.getTableData()
      this.getprintData()
    }
  }
}
</script>

<style lang="scss">
.bill_printing {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  // justify-content: space-between;
  // background-color: pink;
  .el-tooltip {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .print_control {
    width: 90%;
    height: 10%;
    min-height: 125px;
    margin-top: 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    .el-icon-printer {
      margin-left: 20px;
    }
  }
  .print_browse {
    width: 90%;
    margin-top: 40px;
    height: 80%;
    // min-height: 210mm;
    background-color: #fff;
    // display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    padding-top: 20mm;
  }
}
.print_browse_main {
  margin: 0 auto;
  width: 297mm;
  // height: 210mm;
  display: flex;
  flex-direction: column;
  .print_browse_top {
    position: relative;
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    // background-color: rgb(143, 45, 45);
    box-sizing: border-box;
    .print_browse_title {
      position: relative;
      text-align: center;
      font-weight: 700;
      margin-bottom: 2mm;
      font-size: 10mm;
      width: 70%;
    }
    .print_browse_date {
      position: absolute;
      font-weight: 700;
      // letter-spacing: 0.5mm;
      margin-bottom: 2mm;
      right: 30mm;
      // width: 30%;
      // width: 50%;
    }
  }
  .print_browse_mid {
    width: 100%;
    background-color: rgb(121, 48, 139);
    box-sizing: border-box;
    border: 1px solid #000;
    .bzinfo {
      padding: 0;
      margin: 0;
      .el-textarea__inner {
        padding: 0;
        margin: 0;
        border: 0;
        width: 100%;
        height: 100%;
        resize: none;
      }
    }
    .customer_name {
      width: 100%;
      height: 6mm;
      border-bottom: 1px solid #000;
      box-sizing: border-box;
      padding-left: 1mm;
      background-color: #fff;
    }
    .customer_message {
      border-bottom: 1px solid #000;
      background-color: #fff;
      padding-left: 1mm;
      height: 6mm;
      display: flex;
      div {
        margin-right: 20mm;
      }
    }
    .el-table--border td {
      border-right: 1px solid #000;
    }
    .el-table {
      border-bottom: 1px solid #000;
      .el-table__row {
        color: black;
      }
      .el-table__header {
        .has-gutter {
          th {
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            .cell {
              text-align: center;
              color: black;
            }
          }
        }
      }
      td {
        border-bottom: 1px solid #000;
        text-align: center;
      }
    }
    .customer_total {
      height: 10mm;
      line-height: 10mm;
      border-top: 1px solid #000;
      // border-bottom: 1px solid #000;
      background-color: #fff;
      display: flex;
      .customer_lable {
        border-right: 1px solid #000;
        margin-right: 210mm;
      }
    }
  }
  .print_browse_bottom {
    width: 100%;
    height: 25%;
    // background-color: rgb(60, 168, 46);
    .price_think {
      width: 100%;
      height: 20mm;
      line-height: 20mm;
      font-size: 6mm;
      background-color: #fff;
      .price {
        text-decoration: underline;
      }
    }
    .private_play {
      font-weight: 700;
    }
  }
}
</style>